export default __webpack_public_path__ + "static/1043-4de57171cbe1891bee61f3cfb115006b.gif";